import React from "react";

import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";
import TextLoop from "react-text-loop";
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import TabTwo from "../elements/tab/TabTwo";
import ContactThree from "../elements/contact/ContactThree";
import PortfolioList from "../elements/portfolio/PortfolioList";
import BlogContent from "../elements/blog/BlogContent";

const SlideList = [
  {
    textPosition: "text-left",
    category: "Antoine Mincy",
    description: "",
    buttonText: "My Github",
    buttonLink: "https://github.com/ajmincy",
  },
];
const PortfolioLanding = () => {
  let title = "About Me",
    description =
      "The aspect I enjoy most about the software development community is that it is always evolving and therefore to excel at it you must continue to grow. I am at my best when I am being challenged and learning new things. This goes hand to hand with my other passions which are bouldering, OCRs, and basketball.";
  return (
    <div className="active-dark">
      <Helmet pageTitle="Antoine Mincy" />

      <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" />
      {/* Start Slider Area   */}
      <div id="home" className="fix">
        <div className="slider-wrapper">
          {/* Start Single Slide */}
          {SlideList.map((value, index) => (
            <div
              className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image bg_image--34"
              key={index}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className={`inner ${value.textPosition}`}>
                      <h3>
                        <span className="neon"> {value.category}</span>
                      </h3>
                      <h1 className="title">
                        Working with
                        <br />
                        <TextLoop>
                          <span> Javascript.</span>
                          <span> Cypress.</span>
                          <span> React.</span>
                          <span> Figma.</span>
                          <span> PHP.</span>
                          <span> React Native.</span>
                          <span> Jenkins.</span>
                          <span> AngularJs.</span>
                          <span> API.</span>
                        </TextLoop>{" "}
                      </h1>
                      <br />
                      <h3>
                        <span className="neon">Create More.</span>
                      </h3>
                      <h3>
                        <span className="neon">Consume Less.</span>
                      </h3>
                      {value.description ? (
                        <p className="description">{value.description}</p>
                      ) : (
                        ""
                      )}
                      {value.buttonText ? (
                        <div className="slide-btn">
                          <a
                            className="rn-button-style--2 btn-primary-color"
                            href={`${value.buttonLink}`}
                          >
                            {value.buttonText}
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* End Single Slide */}
        </div>
      </div>
      {/* End Slider Area   */}

      {/* Start About Area */}
      <div id="about" className="fix">
        <div className="about-area ptb--120  bg_color--1">
          <div className="about-wrapper">
            <div className="container">
              <div className="row row--35 align-items-center">
                <div className="col-lg-5">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src="/assets/images/about/about-11.jpg"
                      alt="About Images"
                    />
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="about-inner inner">
                    <div className="section-title">
                      <h2 className="title">{title}</h2>
                      <p className="description">{description}</p>
                    </div>
                    <div className="row mt--30">
                      <TabTwo tabStyle="tab-style--1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End About Area */}

      {/* Start Portfolio Area */}
      <div id="portfolio" className="fix">
        <div className="portfolio-area ptb--120 bg_color--5">
          <div className="portfolio-sacousel-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                    <h2 className="title">My Project Roadmap</h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <PortfolioList
                  styevariation="text-center mt--40"
                  column="col-lg-4 col-md-6 col-sm-6 col-12"
                />
              </div>
              <div className="row">
                <div className="col-lg-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Portfolio Area */}

      {/* Start Blog Area */}
      <div id="blog" className="fix">
        <div className="rn-blog-area ptb--120 bg_color--1 mb-dec--30">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="section-title text-center">
                  <h2>My Blog</h2>
                </div>
              </div>
            </div>
            <div className="row mt--60 mt_sm--40">
              <BlogContent />
            </div>

            <div className="view-more-btn mt--60 mt_sm--30 text-center">
              <a className="rn-button-style--2 btn-solid" href="https://dev.to/simplymincy">
                <span>View on Dev.to</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* End Blog Area */}

      {/* Start COntact Area */}
      <div id="contact" className="fix">
        <div className="rn-contact-area ptb--120 bg_color--5">
          <ContactThree
            contactImages="/assets/images/about/about-9.jpg"
            contactTitle="Contact"
          />
        </div>
      </div>
      {/* End COntact Area */}

      <FooterTwo />
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </div>
  );
};

export default PortfolioLanding;
